// Remove '<br>' in contact-form
document.addEventListener('DOMContentLoaded', function() {
  let forms = document.querySelectorAll('.wpcf7') // NodeLists
  for (let form of forms) {
    let pList = form.querySelectorAll('p')
    for (let p of pList) {
      let brList = p.querySelectorAll('br')
      for (let br of brList) {
        br.parentNode.removeChild(br)
      }
    }
  }
})


// WEBPACK FOOTER //
// ./support.js